import React from 'react'
import { CartProductBlock, CartProductQuantity, CartProductTitle, CartProductTitleBlock, CartProductWrapper, CartTopping, CartToppings, CartToppingTitle } from '../index.styled'

const CartProduct = React.memo(({ item, index, isMenuProduct = false, isMenuCanceled = false }) => {
	const testId = (isMenuProduct ? 'menu-product-' : 'product-') + `${index}-` + item?.name
	const isCanceledItem = item?.status === 'CANCELED'
	const titleLayout = (isMenuProduct ? 'menu ' : '') + ((isCanceledItem || isMenuCanceled) ? 'canceled ' : '')
	const layout = (isMenuProduct ? 'menu ' : '')

	return (
		<CartProductWrapper data-testid={testId} className={layout}>
			<CartProductBlock className={layout}>
				<CartProductTitleBlock>
					<CartProductTitle className={titleLayout}>{item?.name}</CartProductTitle>
					<CartProductQuantity data-testid={testId + '-quantity'} className={titleLayout}>x{item?.quantity}</CartProductQuantity>
				</CartProductTitleBlock>
				{item?.items?.length > 0 &&
					<CartToppings className={layout}>
						{item?.items?.map((subItem, subItemIndex) => {
							const toppingLayout = ((isCanceledItem || isMenuCanceled || subItem?.status === 'CANCELED') ? 'canceled ' : '')
							return (
								<CartTopping key={subItemIndex}>
									<CartToppingTitle className={toppingLayout}>{subItem.name} x{subItem.quantity}</CartToppingTitle>
								</CartTopping>
							)
						})}
					</CartToppings>}
			</CartProductBlock>
		</CartProductWrapper>
	)
})

CartProduct.displayName = 'CartProduct'
export default CartProduct
